import { ALLOW_PATHS } from "../../constants/Security";

const initialState = {
    allowedPaths: []
};

function allowPaths(state, {paths}) {
    return {...state, allowedPaths: paths};
}

export default function loginReducer(state= initialState, {type, payload}) {
    switch (type) {
        case ALLOW_PATHS:
            return allowPaths(state, payload);
        default:
            return state;
    };
};